const escapeCell = value => {
  const text = value == null ? '' : String(value);
  if (/[;"\n]/.test(text)) return `"${text.replace(/"/g, '""')}"`;
  return text;
};

const toCsv = rows =>
  `\uFEFF${rows.map(row => row.map(escapeCell).join(';')).join('\n')}`;

const durationCell = (value, formatDuration) =>
  value ? formatDuration(value) : '';

const operationRows = (operation, labels, formatDuration) => [
  [],
  [labels.operationTitle],
  [labels.companies, operation.companiesCount || 0],
  [labels.contacts, operation.contactsCount || 0],
  [labels.engagements, operation.conversationsCount || 0],
  [labels.messages, operation.messagesCount || 0],
  [labels.resolved, operation.resolvedConversationsCount || 0],
  [
    labels.avgHandling,
    durationCell(operation.avgResolutionTime, formatDuration),
  ],
  [
    labels.firstResponse,
    durationCell(operation.avgFirstResponseTime, formatDuration),
  ],
  [labels.replyTime, durationCell(operation.avgReplyTime, formatDuration)],
];

const companyRows = (rows, labels, formatDuration) => [
  [
    labels.rank,
    labels.company,
    labels.domain,
    labels.contacts,
    labels.engagements,
    labels.messages,
    labels.resolved,
    labels.totalHandling,
    labels.avgHandling,
    labels.firstResponse,
    labels.replyTime,
  ],
  ...rows.map((row, index) => [
    index + 1,
    row.name || '',
    row.domain || '',
    row.contactsCount || 0,
    row.conversationsCount || 0,
    row.messagesCount || 0,
    row.resolvedConversationsCount || 0,
    durationCell(row.totalResolutionTime, formatDuration),
    durationCell(row.avgResolutionTime, formatDuration),
    durationCell(row.avgFirstResponseTime, formatDuration),
    durationCell(row.avgReplyTime, formatDuration),
  ]),
];

const contactRows = (rows, labels, formatDuration) => [
  [
    labels.rank,
    labels.contact,
    labels.email,
    labels.phone,
    labels.engagements,
    labels.messages,
    labels.resolved,
    labels.totalHandling,
    labels.avgHandling,
    labels.firstResponse,
    labels.replyTime,
  ],
  ...rows.map((row, index) => [
    index + 1,
    row.name || '',
    row.email || '',
    row.phoneNumber || '',
    row.conversationsCount || 0,
    row.messagesCount || 0,
    row.resolvedConversationsCount || 0,
    durationCell(row.totalResolutionTime, formatDuration),
    durationCell(row.avgResolutionTime, formatDuration),
    durationCell(row.avgFirstResponseTime, formatDuration),
    durationCell(row.avgReplyTime, formatDuration),
  ]),
];

export const buildContactRankingCsv = ({
  ranking,
  rows,
  operation,
  title,
  periodLabel,
  labels,
  formatDuration,
}) => {
  const table =
    ranking === 'contacts'
      ? contactRows(rows, labels, formatDuration)
      : companyRows(rows, labels, formatDuration);

  return toCsv([
    [title],
    [periodLabel],
    ...operationRows(operation || {}, labels, formatDuration),
    [],
    ...table,
  ]);
};
